<template>
    <vue-good-table class="col-12 top-24" v-if="Contracts"
        :columns="columns"
        :rows="this.Contracts"
        :pagination-options="{
            enabled: true,
            perPage: 25
        }"
        :search-options="{
            enabled: true
        }"
    />

    <div class="col-12" v-else>
        Идёт загрузка
    </div>
</template>
  
  <script>
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import moment from 'moment'

  export default {
    components: { VueGoodTable, },
    data() {
      return {
        columns: [
            {
                label: 'Наименование договора',
                field: 'ContractName',
            },
            {
                label: 'Номер',
                field: 'ContractID',
                type: 'number',
            },
            {
                label: 'Дата начала действия',
                field: 'ContractDateStart',

            },
            {
                label: 'Дата окончания действия',
                field: 'ContractDateFinish',

            },
        ]
      }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        Contracts() {
            return this.$store.state.polygon_company.Contracts
        },
        getContracts() {
            return this.$store.state.polygon_company.Contracts.sort((a, b) => b.Amount - a.Amount)
        },
    },
    created() {
        this.$store.dispatch("fetchPolygonContracts", this.currentUser.company_inn);
    },
    methods: {
        format_date(value, time='NaN'){
            if (value) {
                if (time != 'NaN') {
                return moment(String(value)).format('DD.MM.YYYY')
                } else {
                return moment(String(value)).format('DD.MM.YYYY HH:mm')
                }
            }
        },
        Change(number) {
            number = Math.trunc(number)
            return number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') + ' руб.'
        }
    }
  };
  </script>
  